// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import FormOutlined from '/home/crm/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/FormOutlined';
import CalendarOutlined from '/home/crm/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/CalendarOutlined';
export default { FormOutlined, CalendarOutlined };
